import { render, staticRenderFns } from "./welcom-page.vue?vue&type=template&id=48b1b1ee&scoped=true&"
import script from "./welcom-page.vue?vue&type=script&lang=js&"
export * from "./welcom-page.vue?vue&type=script&lang=js&"
import style0 from "./welcom-page.vue?vue&type=style&index=0&id=48b1b1ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b1b1ee",
  null
  
)

export default component.exports